import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { HistoryChatsService } from './historyChatsApi';
import { IHistoryChatListState } from '../../../../interfaces/history-chats/IHistoryChatsList';
import { AxiosError } from 'axios';

const initialState: IHistoryChatListState = {
    chatIsLoading: false,
    chatsAreLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchHistoryChats = createAsyncThunk<any, undefined>(
    'historyChats/tryToFetchHistoryChats',
    async () => {
        const result = await HistoryChatsService.tryToFetchHistoryChats();
        return result?.data?.data;
    },
);

export const tryToGetExistingTopic = createAsyncThunk<any, undefined>(
    'historyChats/tryToGetExistingTopic',
    async () => {
        const result = await HistoryChatsService.tryToGetExistingTopic();
        return result?.data?.data;
    },
);

export const tryToFetchSingleChat = createAsyncThunk<any, string>(
    'historyChats/tryToFetchSingleChat',
    async (id: string) => {
        const result = await HistoryChatsService.tryToFetchSingleChat(id);
        return result?.data;
    }
);

export const tryToAddActionForChat = createAsyncThunk<any, any>(
    'historyChats/tryToAddActionForChat',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const result = await HistoryChatsService.tryToAddActionForChat(id, data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const tryToGetPaymentLink = createAsyncThunk<any, any>(
    'historyChats/tryToGetPaymentLink',
    async (data, { rejectWithValue }) => {
        try {
            const result = await HistoryChatsService.tryToGetPaymentLink(data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const tryToGetChangeCardLink = createAsyncThunk<any, any>(
    'historyChats/tryToGetChangeCardLink',
    async (data, { rejectWithValue }) => {
        try {
            const result = await HistoryChatsService.tryToGetChangeCardLink(data);
            return result.data;
        } catch (error) {
            const err: any = error as AxiosError;
            return rejectWithValue(err?.response?.data?.message);
        }
    },
);

export const historyChatsSlice = createSlice({
    name: 'historyChats',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchHistoryChats
            .addCase(tryToFetchHistoryChats.pending, (state) => {
                state.chatsAreLoading = true;
            })
            .addCase(tryToFetchHistoryChats.rejected, (state) => {
                state.chatsAreLoading = false;
            })
            .addCase(tryToFetchHistoryChats.fulfilled, (state, action) => {
                state.chatsAreLoading = false;
                state.historyChats = action.payload;
            })

            // tryToFetchSingleChat
            .addCase(tryToFetchSingleChat.pending, (state) => {
                state.chatIsLoading = true;
            })
            .addCase(tryToFetchSingleChat.rejected, (state) => {
                state.chatIsLoading = false;
            })
            .addCase(tryToFetchSingleChat.fulfilled, (state, action) => {
                state.chatIsLoading = false;
                state.historyChat = action.payload;
            })
    },
});

export default historyChatsSlice.reducer;